import ReservationResource from "./reservation.resource";

const reservationModule = angular
  .module("app.resources.reservation", [])
  .service("Reservation", ReservationResource);

export default reservationModule;



// WEBPACK FOOTER //
// ./src/resources/reservation/reservation.module.js